import invoices from "../../asset/images/InvoiceFactoring.svg";
import letterofcredit from "../../asset/images/creditLine.svg";
import trade from "../../asset/images/workingCapital.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import search from "../../asset/images/search-normal.svg";
import ComponentLoader from "../../component/componentloader";
import axios from "axios";
import invoiceimg from "../../asset/images/invoice.svg";
import dot from "../../asset/images/simpledot.png";
import { useSelector } from "react-redux";
import currencyPairCheck from "../../utilities/currencyPairCheck";
import AmountCheck from "../../component/amountCheck";

function History() {
    const navigate = useNavigate();
    const [selectedIndex, setselectedIndex] = useState(-1);
    const [mydate, setmydate] = useState(new Date());
    const [invoice, setinvoices] = useState([]);
    const selectorbusiness = useSelector((state) => state.business);

    const [inputSearch, setinputsearch] = useState("");
    const [loaderset, setloaderset] = useState(true);
    const [tab, settab] = useState("all");
    const [maintab, setmaintab] = useState("Instruments");
    const [searchbank, setsearchbank] = useState("");
    const [show, sethsow] = useState(false);
    const [transaction, settransaction] = useState([]);
    const [shownotice, setshownotice] = useState(false);
    const [summary, setSummary] = useState([]);

    const businessIdHeaderConfig = {
        headers: { "x-business-id": selectorbusiness?._id },
    };

    const getfinance = (index) => {
        setselectedIndex(index);
        if (index === 0) {
            navigate("/finance/invoice");
        } else if (index === 1) {
            navigate("/trade_of_credit/home");
        }
    };

    useEffect(() => {
        if (!selectorbusiness?._id) return;
        const fetchaccount = async () => {
            setloaderset(true);
            try {
                const res = await axios.get("/v1/finance/all", {
                    headers: { "x-business-id": selectorbusiness._id },
                });
                setinvoices(res.data.slice(0, 10));
            } catch (error) {
                console.error("Error fetching history:", error);
            } finally {
                setloaderset(false);
            }
        };

        fetchaccount();
    }, [selectorbusiness?._id]);

    useEffect(() => {
        const fetchSummary = async () => {
            await axios
                .get("/v1/finance/summery", businessIdHeaderConfig)
                .then((res) => {
                    setSummary(res.data);
                    //  console.log(res);
                })
                .catch((e) => {
                    setSummary([]);
                    console.log(e);
                });
        };
        selectorbusiness?._id && fetchSummary();
    }, [selectorbusiness]);
    //console.log(invoice);

    const filteredData = invoice.filter(
        (item) =>
            (item.requestedAmount && item.requestedAmount.toString().includes(inputSearch)) ||
            (item.currency && item.currency.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.tenure && item.tenure.toString().includes(inputSearch)) ||
            (item.user && item.user.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.invoiceType &&
                item.invoiceType.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.paymentStatus &&
                item.paymentStatus.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.requestTitle &&
                item.requestTitle.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.annualRevenue && item.annualRevenue.toString().includes(inputSearch)) ||
            (item.annualTurnOver && item.annualTurnOver.toString().includes(inputSearch)) ||
            (item.businessName && item.businessName.toString().includes(inputSearch)) ||
            (item.financeType && item.financeType.toString().includes(inputSearch)) ||
            (item.loanAmount && item.loanAmount.toString().includes(inputSearch))
    );

    const filterInvoice = filteredData.filter((item) =>
        item.status?.toLowerCase()?.includes(searchbank?.toLowerCase())
    );

    invoice.sort((a, b) => a.createdAt.localeCompare(b.createdAt, "es", { sensitivity: "base" }));
    let datass = filterInvoice.reduce((r, e) => {
        let alphabet = new Date(e.createdAt).toDateString();
        if (!r[alphabet])
            r[alphabet] = {
                alphabet,
                record: [],
            };

        r[alphabet].record.push(e);
        return r;
    }, {});
    let result = Object.values(datass);

    return (
        <div
            className="border-0 card"
            style={{
                minHeight: "704px",
                borderRadius: "16px",
            }}
        >
            <div className="card-body" style={{ padding: "30px" }}>
                <div style={{ marginTop: "30px" }}>
                    <div className="main-c-flex flex flex-col gap-8 w-full max-w-[864px] mx-auto">
                        <div className="flex flex-col gap-4 tab-search">
                            <div className="flex justify-start gap-2 p-1 bg-white rounded-lg">
                                <div
                                    className={`px-4 py-2 text-center rounded cursor-pointer flex justify-center items-center font-medium ${
                                        tab === "all"
                                            ? "bg-[#EBE4FF] text-[#6F00FF]"
                                            : "text-[#667085]"
                                    }`}
                                    onClick={() => {
                                        settab("all");
                                        setsearchbank("");
                                    }}
                                >
                                    All
                                </div>
                                <div
                                    className="px-4 py-2 text-center rounded cursor-pointer flex justify-center items-center font-medium
  bg-[#EBE4FF]:tab-[Processing] text-[#6F00FF]:tab-[Processing] text-[#667085]:tab-[not-Processing]"
                                    onClick={() => {
                                        settab("Processing");
                                        setsearchbank("Processing");
                                    }}
                                >
                                    {" "}
                                    Processing
                                </div>
                                <div
                                    className={`px-4 py-2 text-center rounded cursor-pointer flex justify-center items-center font-medium ${
                                        tab === "Completed"
                                            ? "bg-[#EBE4FF] text-[#6F00FF]"
                                            : "text-[#667085]"
                                    }`}
                                    onClick={() => {
                                        settab("Completed");
                                        setsearchbank("Completed");
                                    }}
                                >
                                    Completed
                                </div>
                                <div
                                    className={`px-4 py-2 text-center rounded cursor-pointer flex justify-center items-center font-medium ${
                                        tab === "Declined"
                                            ? "bg-[#EBE4FF] text-[#6F00FF]"
                                            : "text-[#667085]"
                                    }`}
                                    onClick={() => {
                                        settab("Declined");
                                        setsearchbank("Declined");
                                    }}
                                >
                                    Declined
                                </div>

                                <div
                                    className={`px-4 py-2 text-center rounded cursor-pointer flex justify-center items-center font-medium ${
                                        tab === "Due"
                                            ? "bg-[#EBE4FF] text-[#6F00FF]"
                                            : "text-[#667085]"
                                    }`}
                                    onClick={() => {
                                        settab("Due");
                                        setsearchbank("Due");
                                    }}
                                >
                                    Due
                                </div>
                            </div>
                            <div className="bg-[#ECEFF3] flex gap-2 h-12 rounded-lg px-2 items-center">
                                <img src={search} alt="" />
                                <input
                                    type="text"
                                    className="text-[#667085] text-sm font-normal leading-[19.6px] w-full outline-none bg-[#ECEFF3] border-none !shadow-none"
                                    onChange={(e) => {
                                        setinputsearch(e.target.value);
                                    }}
                                    placeholder="Search finance type, amount and more"
                                />
                            </div>
                        </div>
                        {loaderset === false ? (
                            <>
                                {" "}
                                {result.length === 0 && (
                                    <div className="no-flex-c h-[460px] overflow-auto p-4 sm:p-6 rounded-2xl flex items-center justify-center">
                                        <div className="flex flex-col items-center justify-center w-full gap-6">
                                            <img src={invoiceimg} alt="Invoice" />
                                            <div className="flex flex-col items-center gap-2">
                                                <h3 className="font-bold text-[#101828] text-[18px] leading-[24.3px] text-center">
                                                    There are no invoices yet
                                                </h3>
                                                <span className="text-[#667085] text-[14px] leading-[19.6px] font-normal text-center max-w-[229px]">
                                                    Start adding your invoices to Tradevu to see
                                                    them here.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {invoice.length >= 1 && (
                                    <div style={{ height: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "16px",
                                            }}
                                        >
                                            {result?.reverse()?.map((invoce, index) => (
                                                <div key={index}>
                                                    <label className="text-[#98A2B3] text-[12px] font-normal leading-[16.2px] uppercase">
                                                        {new Date(
                                                            invoce.alphabet
                                                        ).toDateString() ===
                                                        new Date().toDateString()
                                                            ? "Today"
                                                            : new Date().getMonth() - 1 ===
                                                              new Date(invoce.alphabet).getMonth()
                                                            ? "Last Month"
                                                            : new Date(
                                                                  invoce.alphabet
                                                              ).toDateString()}
                                                    </label>
                                                    <div className="shadow-[0_0_0_0.5px] shadow-[#E7E9FB] rounded-lg p-4">
                                                        {invoce.record
                                                            ?.reverse()
                                                            ?.map((item, indexs) => (
                                                                <div
                                                                    key={indexs}
                                                                    className="flex items-center justify-between p-4 cursor-pointer"
                                                                    onClick={() => {
                                                                        sethsow(true);
                                                                        settransaction(item);
                                                                    }}
                                                                >
                                                                    {/* Left Section */}
                                                                    <div className="flex gap-2">
                                                                        <img
                                                                            src={
                                                                                item.financeType ===
                                                                                "tradeCredit"
                                                                                    ? trade
                                                                                    : item.financeType ===
                                                                                      "creditLine"
                                                                                    ? letterofcredit
                                                                                    : invoices
                                                                            }
                                                                            alt=""
                                                                        />
                                                                        <div className="flex flex-col gap-1">
                                                                            <span className="text-[#101828] font-semibold text-[14px] leading-[19.6px]">
                                                                                {item?.requestTitle ? (
                                                                                    item.requestTitle
                                                                                ) : item?.firstName ? (
                                                                                    <>
                                                                                        {
                                                                                            item?.firstName
                                                                                        }{" "}
                                                                                        {
                                                                                            item?.lastName
                                                                                        }
                                                                                    </>
                                                                                ) : (
                                                                                    item.financeType ===
                                                                                        "tradeCredit" &&
                                                                                    "Working Capital"
                                                                                )}
                                                                            </span>
                                                                            <span className="text-[#667085] tracking-[2%] font-normal leading-[16.2px] text-[14px] flex items-center">
                                                                                {item.financeType ===
                                                                                "tradeCredit"
                                                                                    ? "Working Capital"
                                                                                    : item.financeType ===
                                                                                      "creditLine"
                                                                                    ? "Credit Line"
                                                                                    : "Finance"}
                                                                                <img
                                                                                    src={dot}
                                                                                    alt=""
                                                                                    className="mx-1"
                                                                                />
                                                                                <span
                                                                                    className={`text-[14px] tracking-[2%] font-normal leading-[16.2px] ${
                                                                                        item?.status ===
                                                                                        "SUBMITTED"
                                                                                            ? "text-[#F79009]"
                                                                                            : item?.status ===
                                                                                              "DUE"
                                                                                            ? "text-crimson"
                                                                                            : [
                                                                                                  "COMPLETED",
                                                                                                  "APPROVED",
                                                                                              ].includes(
                                                                                                  item?.status
                                                                                              )
                                                                                            ? "text-[#12B76A]"
                                                                                            : item?.status ===
                                                                                              "DECLINED"
                                                                                            ? "text-[#F04438]"
                                                                                            : item?.status ===
                                                                                              "PROCESSING"
                                                                                            ? "text-[#6F00FF]"
                                                                                            : "text-[#F79009]"
                                                                                    }`}
                                                                                >
                                                                                    {item?.status ===
                                                                                    "SUBMITTED"
                                                                                        ? "PENDING"
                                                                                        : item?.status}
                                                                                </span>
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Right Section */}
                                                                    <div className="flex flex-col gap-1 text-right">
                                                                        <span className="text-[#344054] font-semibold text-[14px] leading-[19.6px]">
                                                                            {currencyPairCheck(
                                                                                item.currency
                                                                            )}
                                                                            {AmountCheck(
                                                                                item.loanAmount !==
                                                                                    undefined
                                                                                    ? item.loanAmount
                                                                                    : item.requestedAmount
                                                                            )}
                                                                        </span>
                                                                        <span className="text-[#667085] tracking-[2%] font-normal leading-[16.2px]">
                                                                            {new Date(
                                                                                item.createdAt
                                                                            ).toLocaleTimeString()}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}{" "}
                            </>
                        ) : (
                            <ComponentLoader />
                        )}{" "}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default History;
